import { DateTime } from "luxon";
import type { AttentionHeaderBadge } from "./attention-header";

export interface TeenSubtitleInput {
  ageYears: number | null;
  pronouns: string | null;
  gender: string | null;
}

export interface TeenBadgeInput {
  reactivated: boolean;
  rematched: boolean;
}

export function computeAgeYears(
  birthday: Date | string | null | undefined,
  now: DateTime = DateTime.now(),
): number | null {
  if (!birthday) {
    return null;
  }
  const birthDate =
    birthday instanceof Date
      ? DateTime.fromJSDate(birthday)
      : DateTime.fromISO(birthday);
  if (!birthDate.isValid) {
    return null;
  }
  const years = Math.floor(now.diff(birthDate, "years").years);
  return years >= 0 ? years : null;
}

export function resolveTeenSubtitleParts(input: TeenSubtitleInput): string[] {
  const parts: string[] = [];
  if (input.ageYears !== null) {
    parts.push(`${input.ageYears} y/o`);
  }
  if (input.pronouns) {
    parts.push(input.pronouns);
  }
  if (input.gender) {
    parts.push(input.gender);
  }
  return parts;
}

export function resolveTeenHeaderBadges(
  input: TeenBadgeInput,
): AttentionHeaderBadge[] {
  const badges: AttentionHeaderBadge[] = [];
  if (input.reactivated) {
    badges.push({ kind: "reactivated", label: "Reactivated" });
  }
  if (input.rematched) {
    badges.push({ kind: "rematched", label: "Re-matched" });
  }
  return badges;
}
